if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      // `scrolledPast` mirrors the previous intersection-only rule; `scrollingUp`
      // is the new gate — the panel only appears on scroll-up so downward reads
      // aren't interrupted.
      this.scrolledPast = false;
      this.scrollingUp = false;
      this.lastScrollY = window.scrollY;

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.directionHandler) window.removeEventListener('scroll', this.directionHandler);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.scrolledPast = !(entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.scrolledPast = !entry.isIntersecting;
          }
          this.updateVisibility();
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      // Threshold ignores subpixel jitter so a rubber-band bounce doesn't flip
      // direction; the panel keeps a stable state through small tremors.
      this.directionHandler = () => {
        const y = window.scrollY;
        const delta = y - this.lastScrollY;
        if (Math.abs(delta) > 4) {
          this.scrollingUp = delta < 0;
          this.lastScrollY = y;
          this.updateVisibility();
        }
      };
      window.addEventListener('scroll', this.directionHandler, { passive: true });

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    updateVisibility() {
      const shouldShow = this.scrolledPast && this.scrollingUp;
      this.classList.toggle('sticky-atc-panel--out', !shouldShow);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
